<template>
  <b-modal ref="modal" title="انتخاب حساب" size="md" ok-only ok-title="تایید" @ok="onOk">
    <accounts-titles @selectAccountTitle="selectAccountTitle" @dblClicked="dblClicked"></accounts-titles>
  </b-modal>
</template>
<script>
import AccountsTitles from "../pages/AccountsTitles.vue";
export default {
  data() {
    return {
      unit: null
    };
  },
  props: {
    product: {},
    model: {
      default() {
        return {
          price: 0,
          number: 0,
          description: ""
        };
      },
      type: Object
    }
  },
  components: {
    AccountsTitles
  },
  methods: {
    dblClicked() {
      this.$refs.modal.hide();
      this.onOk();
    },
    selectAccountTitle(data) {
      this.$emit("selectAccountTitle", data);
    },
    onOk() {
      this.$emit("onOk");
    },
    openModal() {
      this.$refs.modal.show();
    }
  }
};
</script>
